import { SVGAttributes } from 'react';

export const SunshineYellowCircle = ({ className }: SVGAttributes<SVGSVGElement>) => (
  <svg
    className={className}
    width="80"
    height="23"
    viewBox="0 0 80 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="39.5847" cy="-16.4973" r="39.4988" fill="#F4C500" />
  </svg>
);

SunshineYellowCircle.displayName = 'HiringHero_SunshineYellowCircle';
